import React, { useEffect, useState, useRef } from 'react';
import { Redirect } from "react-router-dom";
import { ChromePicker } from 'react-color';
import { useCoverLetter } from '../../../context/CoverLetterContext';
import { DEFAULT_COVERLETTER_TEMPLATE_COLOR, FONT_FAMILIES, FONT_SIZES, LINE_SPACING } from '../../../constants/constants';
// import '../../assets/scss/app/cover-letter-screens/letter-form.scss';
const StyleOptions = (props) => {
    const pickerRef = useRef();
    const dropdownRef1 = useRef();
    const dropdownRef2 = useRef();
    const dropdownRef3 = useRef();
    const [openFFDropDown, setOpenFFDropDown] = useState(false);
    const [openFSDropDown, setOpenFSDropDown] = useState(false);
    const [openLSDropDown, setOpenLSDropDown] = useState(false);
    const [showColorPicker, setShowColorPicker] = useState(false);
    const {
        content_font_family,
        content_font_size,
        content_line_spacing,
        custom_template_color,
        active_template,
        handlers: {
            save,
            update2Preview,
        },
    } = useCoverLetter();
    const Capitalize = (text) => {
        return text.charAt(0).toUpperCase() + text.slice(1).replace('-', ' ');
    }
    const onClickOutside = (e) => {
        if (e.target.classList.value != 'text-style') {
            setOpenFFDropDown(false);
            setOpenFSDropDown(false);
            setOpenLSDropDown(false);
        }

        if (e.target.className.length) {
            setShowColorPicker(false);
        }
    }
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (pickerRef.current && !pickerRef.current.contains(event.target)) {
                onClickOutside && onClickOutside(event);
            }
            if (dropdownRef1.current && !dropdownRef1.current.contains(event.target)) {
                onClickOutside && onClickOutside(event);
            }
            if (dropdownRef2.current && !dropdownRef2.current.contains(event.target)) {
                onClickOutside && onClickOutside(event);
            }
            if (dropdownRef3.current && !dropdownRef3.current.contains(event.target)) {
                onClickOutside && onClickOutside(event);
            }
        };
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [onClickOutside]);
    const showColorCode = !custom_template_color.length ? DEFAULT_COVERLETTER_TEMPLATE_COLOR[active_template] : custom_template_color
    return (<>
        <div className="customize-panel">
            <div className="cust-row">
                <div className="style-col">
                    <label htmlFor="textcolor"> Template Color</label>
                    <div className="text-style">
                        <div className="text-style-inner" onClick={() => setShowColorPicker(true)}>
                            <span className="color-picker" style={{ backgroundColor: showColorCode }}>
                                <i className="color-square" ></i>
                            </span>
                            {showColorPicker ? <div className="cover-chrome-picker"  ref={pickerRef}>
                                <ChromePicker
                                    color={showColorCode}
                                    onChange={(e) => { 
                                        props?.setSelectedCustomColor && props.setSelectedCustomColor(e.hex)
                                        update2Preview({ custom_template_color: e.hex },true); }}
                                    // onChangeComplete={(e) => {
                                    //   update2Preview({ custom_template_color: e.hex });
                                    // }}
                                    disableAlpha={true}
                                    
                                />

                            </div> : ''}
                            <span className="color-code">{showColorCode}</span>
                            <i className="icon-right-arrow"></i>
                        </div>
                    </div>
                </div>
                <div className="style-col">
                    <label htmlFor="textfont"> Font</label>
                    <div className="text-style">
                        <span className="text-style-inner" onClick={() => setOpenFFDropDown(!openFFDropDown)}>
                            <span className="name">{content_font_family ? Capitalize(content_font_family) : 'Select Font'} </span>
                            <i className="icon-right-arrow"></i>
                        </span>
                    </div>
                    {openFFDropDown ? <div className="list-outer" ref={dropdownRef1}>
                        <ul className="ul-list">
                            {FONT_FAMILIES.map((value, index) => {
                                return (<li onClick={(e) => {
                                    update2Preview({ content_font_family: value.id }, true);
                                    setOpenFFDropDown(false);
                                }} key={index}>{value.name}</li>)
                            })}
                        </ul>
                    </div> : ''}
                </div>
                <div className="style-col">
                    <label htmlFor="textsize"> Font Size</label>
                    <div className="text-style">
                        <span className="text-style-inner" onClick={() => setOpenFSDropDown(!openFSDropDown)}>
                            <span className="name">{content_font_size ? Capitalize(content_font_size) : 'Medium'}</span>
                            <i className="icon-right-arrow"></i>
                        </span>
                    </div>
                    {openFSDropDown ? <div className="list-outer" ref={dropdownRef2}>
                        <ul className="ul-list">
                            {FONT_SIZES.map((value, index) => {
                                return (<li onClick={(e) => {
                                    update2Preview({ content_font_size: value.id }, true);
                                    setOpenFSDropDown(false);
                                }} key={index}>{value.name}</li>);
                            })}
                        </ul>
                    </div> : ''}
                </div>
                <div className="style-col">
                    <label htmlFor="textspacing">Line Spacing</label>
                    <div className="text-style">
                        <span className="text-style-inner" onClick={() => setOpenLSDropDown(!openLSDropDown)}>
                            <span className="name">{content_line_spacing ? Capitalize(content_line_spacing) : 'Medium'}</span>
                            <i className="icon-right-arrow"></i>
                        </span>
                    </div>
                    {openLSDropDown ? <div className="list-outer" ref={dropdownRef3}>
                        <ul className="ul-list">
                            {LINE_SPACING.map((value, index) => {
                                return (<li onClick={(e) => {
                                    update2Preview({ content_line_spacing: value.id }, true);
                                    setOpenLSDropDown(false);
                                }} key={index}>{value.name}</li>);
                            })}
                        </ul>
                    </div> : ''}
                </div>
            </div>
        </div>
        {/* <div className="color-customize-panel-mb">
            <div className="color-palette">
                <span className="color-label">Colors:</span>
                <ul className="color-selector">
                    <li>
                        <label title="" className="label">
                            <input type="radio" name="select-color" />
                            <span className={`color-selector-radio `} ></span>
                        </label>
                    </li>
                    <li>
                        <label title="" className="label">
                            <input type="radio" name="select-color" />
                            <span className={`color-selector-radio `} ></span>
                        </label>
                    </li>
                </ul>
            </div>
            <div className="multi-color-selector">
                <div className="multiple-color" style={{ position: 'relative' }} onClick={(e) => {
                    setShowColorPicker(true);
                    e.stopPropagation();
                }}>
                    <span className="color-picker">
                        {<i className="color-square"></i>}
                    </span>
                    {showColorPicker ? <div className="quick-chrome-picker-wrap" ref={ddRef}>
                        <ChromePicker /></div> : ''}
                    <label htmlFor="quick-color-picker" className="custom-label">#FFCC00</label>
                </div>
            </div>
        </div> */}
    </>
    );
}

export default StyleOptions;